import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { CardWatchMark } from "@/components/CardWatchLogo";
import { useAuth } from "@/context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  // useRef prevents StrictMode double-firing the exchange
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/signup", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    let acceptedPrivacy = false;
    try {
      acceptedPrivacy = sessionStorage.getItem("cardwatch_privacy_accepted") === "1";
    } catch { /* ignore */ }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId, accepted_privacy: acceptedPrivacy },
          { withCredentials: true }
        );
        try { sessionStorage.removeItem("cardwatch_privacy_accepted"); } catch {}
        // Strip the hash from the URL before navigating away
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        const firstTime = res.data?.first_time || !res.data?.user?.onboarded;
        navigate(firstTime ? "/onboarding" : "/dashboard", { replace: true });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Auth callback failed", e);
        navigate("/signup?error=1", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#060B19] text-white flex items-center justify-center">
      <div
        className="flex flex-col items-center gap-4 text-slate-400"
        data-testid="auth-callback-loader"
      >
        <CardWatchMark size={40} />
        <Loader2 size={20} className="animate-spin text-[#00E676]" />
        <div className="text-sm">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
